import React from 'react'
import styles from './style.module.less'
import Chat from '@common/Chat'

export default store => [
  {
    title: '客户姓名',
    key: 'nick',
    render: ({ nick, user }) => {
      let img = 'http://qnm.hunliji.com/o_1am865g8eeqm1miicua18vf1ic67.png'
      if (user && user.avatar) {
        img = user.avatar + '?imageView2/1/w/64/'
      }
      return (
        <div className={styles.colImg}>
          <img
            src={img}
            style={{ width: 64, height: 64, borderRadius: '50%' }}
          />
          <span>{nick}</span>
        </div>
      )
    }
  },
  {
    title: '报名时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '性别',
    key: 'gender',
    render: ({ gender }) => (
      <span> {{ '1': '新郎', '2': '新娘' }[gender + ''] || '-'}</span>
    )
  },
  {
    title: '联系用户',
    key: 'user_phone',
    render: ({ user_phone, user_id }) => (
      <div>
        {user_phone}
        {(user_phone || '').indexOf('*') > -1 ? (
          <p className={styles.remark} onClick={store.showTips}>
            私信用户
          </p>
        ) : (
          <p>{user_id && <Chat toUserId={user_id} />}</p>
        )}
      </div>
    )
  },
  {
    title: '婚期',
    key: 'weddingDay',
    dataIndex: 'weddingday'
  },
  {
    title: '备注',
    key: 'remark',
    render: ({ remark, id }) => (
      <div>
        <p>{remark}</p>
        <span>
          {remark ? (
            <span
              className={styles.remark}
              onClick={store.showRemarkModal(remark, id)}
            >
              修改
            </span>
          ) : (
            <span
              className={styles.remark}
              onClick={store.showRemarkModal('', id)}
            >
              添加
            </span>
          )}
        </span>
      </div>
    )
  }
]
